import analytics from 'common/analytics';
import { getErrorMessage } from 'application/util/error.util';

import './sign-up.style.sass';
import template from './sign-up.tpl.pug';

class SignUpController {
    /* @ngInject */
    constructor($state, $stateParams, sessionService, navigationService) {
        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;

        this.redirect = $stateParams.redirect || null;
    }

    signUp(name, email, password) {
        return this.sessionService.signUp(name, email, password).then(() => {
            analytics.trackSignUp();

            let { state, params } = this.navigationService.getStateFromRedirectUrl(this.redirect) || {};

            this.$state.go(state || 'authorized.calendar', params || {});
        }, (result) => {
            this.error = getErrorMessage(result, `Sorry but we were not able to sign you up. Please try again later.`);
        });
    }
}

export default {
    selector: 'dbASignUp',
    template: template(),
    controller: SignUpController
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/sign-up/sign-up.cmpt.js